
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'page-details-ui',
  currentProjectVersion: 'static-1.15302',
  depVersions: {
  "page-details-ui": "static-1.15302",
  "ai-components-ui-library": "static-1.4986",
  "apollo-dlb": "static-3.41",
  "apollo-stack-hubspot": "static-3.43",
  "billing-management-service-client": "static-1.3045",
  "content-management-data-lib": "static-1.3675",
  "content-management-details-lib": "static-1.24098",
  "content-management-restrictions-lib": "static-1.3419",
  "crm-object-map": "static-1.1534",
  "data-fetching-client": "static-1.8231",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.650",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.3679",
  "highcharts": "static-8.80",
  "history": "static-4.47",
  "hs-test-utils": "static-1.6626",
  "hub-http": "static-1.4807",
  "hub-http-shared-msw-handlers": "static-1.6846",
  "hubspot-dlb": "static-2.1317",
  "HubStyleTokens": "static-2.10111",
  "I18n": "static-7.1372",
  "jasmine-runner": "static-1.5021",
  "page-lib": "static-1.15246",
  "quartz": "static-1.5374",
  "react-dlb": "static-1.51",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-router-dom": "static-5.26",
  "reporting-dlb": "static-1.53869",
  "reporting-testing-lib": "static-1.2886",
  "settings-ui-lib": "static-1.11184",
  "ui-addon-draggable": "static-1.4362",
  "video-reports-lib": "static-1.28945",
  "webpack-env": "static-1.54",
  "analytics-tools-lib": "static-1.70172",
  "asset-actions-lib": "static-1.38795",
  "attribution-lib": "static-1.36954",
  "campaigns-lib": "static-1.21529",
  "collaboration-sidebar": "static-1.51581",
  "content-intel-content-details-optimize-panel": "static-1.6884",
  "content-management-actions-lib": "static-1.21690",
  "ContentData": "static-1.62652",
  "ContentComponents": "static-2.65533",
  "ContentUtils": "static-1.62575",
  "customer-data-filters": "static-1.46907",
  "customer-data-objects": "static-1.6216",
  "customer-data-properties": "static-1.44984",
  "customer-data-property-utils": "static-1.6543",
  "customer-data-reference-ui-components": "static-1.11605",
  "error-messaging-js": "static-1.3912",
  "ExportDialog": "static-6.9021",
  "file-manager-components": "static-1.17758",
  "foundations-assets": "static-1.3539",
  "foundations-components": "static-1-gcm-text-color-inherit.6",
  "foundations-theming": "static-1.2933",
  "hubspot-apollo-client": "static-1.3447",
  "hubspot-url-utils": "static-1.2969",
  "immutable": "static-2.19",
  "marketing-contacts-lib": "static-1.7755",
  "object-builder-ui-client": "static-1.41174",
  "onboarding-tours": "static-1.13932",
  "PortalIdParser": "static-2.272",
  "property-translator": "static-1.4002",
  "quartz-core": "static-1.4593",
  "quick-fetch": "static-1.2772",
  "react": "static-7.151",
  "react-dom": "static-7.85",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.15222",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reporting-action-components": "static-1.35532",
  "reporting-data": "static-1.60951",
  "reporting-plugins": "static-1.6394",
  "reporting-ui-components": "static-2.58232",
  "reporting-visualizations": "static-1.53031",
  "reselect": "static-2.16",
  "sanitize-text": "static-1.6812",
  "segments-lib": "static-1.26540",
  "SharedI18nStrings": "static-1.162",
  "social-composer-lib": "static-1.52753",
  "ui-addon-emoji-picker": "static-1.8547",
  "ui-addon-form-validation": "static-1.9649",
  "ui-addon-i18n": "static-1.9536",
  "ui-addon-iframeable": "static-1.7520",
  "ui-addon-react-router-dom": "static-1.8237",
  "ui-addon-teams": "static-1.19512",
  "ui-addon-upgrades": "static-9.15771",
  "ui-asset-management-lib": "static-1.8821",
  "ui-business-units-lib": "static-1.7498",
  "ui-forms-editor-automation-lib": "static-1.58589",
  "ui-memberships-settings-lib": "static-1.27627",
  "ui-product-approvals": "static-1.23381",
  "ui-shepherd-react": "static-3.8668",
  "UIComponents": "static-3.7060",
  "usage-tracker": "static-1.6087",
  "usage-tracker-container": "static-1.6077",
  "enviro": "static-4.293",
  "hs-promise-rejection-tracking": "static-1.3967",
  "raven": "static-3.4440",
  "raven-hubspot": "static-1.4747",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.8343",
  "styled-components": "static-2.40",
  "bend-plugin-trellis-migration": "static-1.2293",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.1651",
  "quartz-webpack": "static-1.1598",
  "autolinker": "static-3.11",
  "chatspot-client-types": "static-1.8340",
  "chatspot-core": "static-1.14824",
  "copilot-toolkit": "static-1.5587",
  "cssUtils": "static-1.459",
  "foundations-theming-base": "static-1.1918",
  "hs-story-utils": "static-1.8014",
  "HubStyle": "static-2.10420",
  "icons": "static-2.591",
  "msw": "static-1.39",
  "react-utils": "static-2.4179",
  "rpc-client-utils": "static-1.3351",
  "sanitize": "static-1.2997",
  "sassPrefix": "static-1.129",
  "ui-fonts": "static-1.331",
  "ui-images": "static-2.805",
  "usage-tracker-core": "static-1.5937",
  "graphql": "static-1.58",
  "react-dnd-compat": "static-1.3268",
  "report-customization-components": "static-1.8204",
  "reporting-enablement": "static-1.16305",
  "avatar-components": "static-1.1031",
  "crm-links": "static-1.4743",
  "crm-message-bus": "static-1.35888",
  "crm-object-search-query-utilities": "static-1.5900",
  "customer-data-filters-ui": "static-1.33093",
  "framework-data-schema-resolvers": "static-1.5480",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.6932",
  "framework-data-table": "static-2.8239",
  "inbound-db-meta-service-client": "static-1.2625",
  "HeadJS": "static-2.563",
  "framer-motion": "static-1.40",
  "hs-test-utils-bend-plugin": "static-1.1737",
  "testing-library": "static-1.120",
  "ts-schema": "static-1.2990",
  "i18n-data": "static-1.196",
  "moment-timezone": "static-5.51",
  "jasmine": "static-4.2971",
  "quartz-core-utils": "static-1.2241",
  "StyleGuideUI": "static-3.453",
  "reporting-client-types": "static-1.1767",
  "flux-actions": "static-1.266",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.8852",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9089",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "react-flip-move": "static-1.46",
  "reference-resolvers": "static-1.6773",
  "marketing-platform-lib": "static-1.5284",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "transmute": "static-2.29",
  "user-context": "static-1.3778",
  "atom": "static-1.3865",
  "FormUrlGenerator": "static-2.3335",
  "integrations-lib": "static-1.9831",
  "property-description-translator": "static-1.2466",
  "reference-resolvers-lite": "static-1.6577",
  "reporting-snowflake": "static-1.49575",
  "self-service-api": "static-1.8813",
  "ui-addon-avatars": "static-2.8058",
  "campaigns-build-lib": "static-1.6936",
  "crm-pipelines-api-client-types": "static-1.2972",
  "customer-data-objects-ui-components": "static-1.11507",
  "hs-promise-utils": "static-1.4135",
  "superstore": "static-1.3404",
  "chatspot-widget-iframe": "static-1.14819",
  "frontend-preferences-client": "static-1.6499",
  "hs-lodash": "static-4.45",
  "content-intel-shared": "static-1.7160",
  "cms-field-types": "static-1.3402",
  "FileManagerLib": "static-1.33399",
  "video-data-lib": "static-1.28769",
  "blueimp-md5": "static-1.8",
  "codemirror": "static-5.69",
  "content-embed-lib": "static-1.5976",
  "data-token-picker": "static-1.13811",
  "data-token-views": "static-1.13792",
  "FileManagerCore": "static-1.33258",
  "forms-utils-lib": "static-1.9954",
  "growth-payments-core": "static-1.20577",
  "integrations-error-boundary-lib": "static-1.7245",
  "media-bridge-lib": "static-1.16422",
  "payment-link-components": "static-1.17875",
  "payments-embed-points-lib": "static-1.8969",
  "products-ui-components": "static-1.34761",
  "react-beautiful-dnd": "static-1.13",
  "react-codemirror": "static-1.9223",
  "react-select-plus": "static-1.65",
  "react-tinymce": "static-1.49940",
  "react-virtualized": "static-2.73",
  "rich-text-lib": "static-1.17156",
  "simple-menus-core": "static-1.13332",
  "simple-menus-lib": "static-1.14850",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.49066",
  "tinymce-data": "static-1.35150",
  "tinymce-plugins": "static-1.52180",
  "tinymce-themes": "static-1.51035",
  "videoconference-integration-components": "static-1.4733",
  "content-icons-ui": "static-1.1863",
  "customer-data-ui-utilities": "static-1.8358",
  "deep-diff": "static-1.5",
  "framework-builder-read-service-client": "static-1.2910",
  "framework-data-schema-quick-fetch": "static-1.5385",
  "inbound-db-properties-service-client": "static-1.2797",
  "lodash": "static-4.7",
  "commerce-products-lib": "static-1.4239",
  "conditional-properties-service-client": "static-1.2774",
  "enrichment-properties-lib": "static-1.8990",
  "external-options-client-types": "static-1.2938",
  "google-libphonenumber": "static-1.11",
  "inbounddb-objects-service-types": "static-1.3062",
  "pipeline-validation-client-types": "static-1.2726",
  "bend-plugin-foundations-components": "static-1-gcm-text-color-inherit.6",
  "floating-ui": "static-1.28",
  "react-aria": "static-1.38",
  "tanstack-table": "static-1.23",
  "bend-plugin-foundations-theming": "static-1.1416",
  "apollo-link-hub-http": "static-2.3410",
  "getting-started-shared-tasks": "static-1.11485",
  "growth-data-modal": "static-1.3821",
  "growth-onboarding-confetti": "static-1.1728",
  "navigation-components": "static-1.13525",
  "ui-shepherd-tracker": "static-1.6049",
  "ui-universal-auth": "static-1.7419",
  "dispatcher": "static-1.111",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.635",
  "hubspotter-http": "static-1.3420",
  "hubspotter-http-shared-msw-handlers": "static-1.6844",
  "mobile-manifest-mixins": "static-1.334",
  "platform-navigation-bootstrap": "static-1.11022",
  "csstype": "static-1.38",
  "content-assistance-lib": "static-1.6083",
  "dashboard-lib": "static-1.75050",
  "share-with-third-party-component-lib": "static-1.7272",
  "immer": "static-1.33",
  "campaign-roi-lib": "static-1.2115",
  "reporting-reports": "static-1.60638",
  "account-and-billing-components": "static-1.16083",
  "growth-feature-usage-components": "static-1.4118",
  "foundations-components-test-utils": "static-1-gcm-text-color-inherit.6",
  "magpie-lib": "static-1.4303",
  "navigation-messaging": "static-1.2852",
  "feature-store-service-types": "static-1.3289",
  "growth-monetization-service-types": "static-1.3296",
  "salesImages": "static-1.498",
  "upgrade-management-service-types": "static-1.3280",
  "timezone-utils": "static-2.3886",
  "automation-contextual-components": "static-1.12877",
  "automation-ui-source-apps": "static-1.12439",
  "automation-ui-template": "static-1.39676",
  "automation-ui-types": "static-1.13357",
  "forms-ai-lib": "static-1.2032",
  "redux-actions": "static-3.7",
  "ui-addon-automation-embed": "static-1.12063",
  "ui-forms-components": "static-1.7949",
  "feedback-loader": "static-1.26234",
  "data-quality-ui-library": "static-1.7388",
  "html-to-image": "static-1.29",
  "laboratory-lib": "static-3.5879",
  "ui-addon-opt": "static-4.7280",
  "location-customization-utils-lib": "static-1.3425",
  "fast-json-stable-stringify": "static-1.4",
  "customer-data-filters-ui-msw-helpers": "static-1.15525",
  "persist-promise": "static-1.2367",
  "customer-data-associations": "static-1.5828",
  "redux-toolkit": "static-1.7",
  "getting-started-shared-tasks-store": "static-1.10603",
  "integrations-tracking-lib": "static-1.4096",
  "native-integrations-shared-strings": "static-1.6449",
  "reporting-datasets-permissions-lib": "static-1.6703",
  "FileManagerImages": "static-1.30909",
  "diff-match-patch": "static-1.7",
  "audio-components": "static-1.4234",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.3166",
  "video-components": "static-1.7123",
  "video-embed": "static-1.29612",
  "commerce-analytics-service-client": "static-1.2402",
  "commerce-tours-lib": "static-1.3137",
  "growth-onboarding-reliability": "static-1.3770",
  "sales-checkout-service-client": "static-1.2414",
  "payments-enrollment-embed-lib": "static-1.17054",
  "commerce-shared-components-lib": "static-1.14250",
  "commerce-subscription-lib": "static-1.30501",
  "crm_components": "static-3.86167",
  "crm_data": "static-4.86167",
  "customer-data-tracking": "static-1.5431",
  "browser-eslint": "static-2.57",
  "react-transition-group": "static-1.7",
  "seamless-immutable": "static-7.6",
  "hub-http-contrib": "static-1.1802",
  "interframe": "static-3.3421",
  "ui-addon-sales-email": "static-1.3823",
  "layout-dnd-components": "static-1.10559",
  "layout-dnd-utils": "static-1.9534",
  "NamespacedHubStyle": "static-2.8082",
  "react-immutable-render-mixin": "static-1.9",
  "products-iframe-lib": "static-1.2266",
  "products-ui-components-shared-msw-handlers": "static-1.7231",
  "breeze-intelligence-kit": "static-1.3833",
  "crm-source-interpretation-lib": "static-1.3888",
  "fsm": "static-1.2321",
  "policy-lib": "static-1.5422",
  "idb-keyval": "static-1.20",
  "magpie-types": "static-1.3763",
  "simple-logging-lib": "static-1.1665",
  "platform-infra-nav-components": "static-1.6539",
  "ui-addon-video-player": "static-1.7397",
  "ui-coaching-tips": "static-1.21898",
  "onboarding-scopes": "static-1.5164",
  "account-and-billing-fintech-outages": "static-3.14832",
  "final-form": "static-1.39",
  "fintech-outages-service-client-types": "static-1.11703",
  "subscription-experience-data-types": "static-1.10025",
  "transactions-exp-service-client-types": "static-1.11699",
  "growth-feature-usage-data": "static-1.4337",
  "automation-platform-service-types": "static-1.2055",
  "automation-templates-service-types": "static-1.2782",
  "automation-ui-core": "static-2.15293",
  "redux-mock-store": "static-1.8",
  "form-builder-ui": "static-1.7723",
  "crm-record-cards-service-types": "static-1.2640",
  "universal-page-editor-lib": "static-1.1558",
  "immerable": "static-1.2789",
  "social-insights-client-types": "static-1.17254",
  "outpost": "static-1.2960",
  "onboarding-tours-client": "static-1.3133",
  "growth-onboarding-feedback-components": "static-1.5081",
  "marketplace-ui-apps-core": "static-1.12002",
  "stripe-embedded-components": "static-1.4947",
  "commerce-billing-lib": "static-1.14142",
  "commerce-contract-lib": "static-1.5367",
  "commerce-tools-ui-lib": "static-1.5986",
  "conversations-skeleton-state": "static-1.6017",
  "crm_universal": "static-1.20355",
  "customer-data-content": "static-1.24172",
  "crm_schema": "static-3.86203",
  "customer-data-email": "static-1.15521",
  "layout-data-lib": "static-1.7859",
  "multi-currency-client-types": "static-1.2670",
  "sales-views-client-types": "static-1.2969",
  "trellis-story-utils": "static-1.3177",
  "immutable-less": "static-1.3182",
  "developer-experience-shared-components": "static-1.8700",
  "marketplace-ui-client-types": "static-1.10872",
  "marketplace-ui-common": "static-1.13466",
  "ui-addon-integrations-directory-panel": "static-2.6609",
  "ui-extensibility-client-types": "static-1.2819",
  "stripe-connect-js": "static-1.37",
  "usage-tracker-session-replay": "static-1.2954",
  "utility-belt": "static-1.1200",
  "crm-cards-sdk": "static-1.37381",
  "customer-data-rte": "static-1.28465",
  "cv-backend-services": "static-1.1110",
  "growth-onboarding-empty-states": "static-1.3792",
  "hubspot-prosemirror": "static-1.13061",
  "InboxConnectUtils": "static-4.9281",
  "payments-post-enroll-local-storage-lib": "static-1.3709",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.43",
  "SalesContentIndexUI": "static-3.6837",
  "sequences-lib": "static-1.5650",
  "ui-gdpr-components": "static-1.8878",
  "apps-service-types": "static-1.2816",
  "oauth-service-types": "static-1.2924",
  "nav-meta": "static-1.25162",
  "react-window": "static-1.13",
  "amplitude-session-replay-browser": "static-1.6",
  "crm-actions": "static-1.4683",
  "crm-fe-perf": "static-1.21608",
  "draft-content-plugins": "static-1.23789",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.18984",
  "knowledge-content-types": "static-1.7617",
  "FireAlarmUi": "static-1.3490",
  "sequences-client-types-lib": "static-1.5506"
},
  depPathPrefixes: {
  "page-details-ui": "/page-details-ui/static-1.15302",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.4986",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "billing-management-service-client": "/billing-management-service-client/static-1.3045",
  "content-management-data-lib": "/content-management-data-lib/static-1.3675",
  "content-management-details-lib": "/content-management-details-lib/static-1.24098",
  "content-management-restrictions-lib": "/content-management-restrictions-lib/static-1.3419",
  "crm-object-map": "/crm-object-map/static-1.1534",
  "data-fetching-client": "/data-fetching-client/static-1.8231",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.650",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.3679",
  "highcharts": "/highcharts/static-8.80",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.6626",
  "hub-http": "/hub-http/static-1.4807",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6846",
  "hubspot-dlb": "/hubspot-dlb/static-2.1317",
  "HubStyleTokens": "/HubStyleTokens/static-2.10111",
  "I18n": "/I18n/static-7.1372",
  "jasmine-runner": "/jasmine-runner/static-1.5021",
  "page-lib": "/page-lib/static-1.15246",
  "quartz": "/quartz/static-1.5374",
  "react-dlb": "/react-dlb/static-1.51",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reporting-dlb": "/reporting-dlb/static-1.53869",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.2886",
  "settings-ui-lib": "/settings-ui-lib/static-1.11184",
  "ui-addon-draggable": "/ui-addon-draggable/static-1.4362",
  "video-reports-lib": "/video-reports-lib/static-1.28945",
  "webpack-env": "/webpack-env/static-1.54",
  "analytics-tools-lib": "/analytics-tools-lib/static-1.70172",
  "asset-actions-lib": "/asset-actions-lib/static-1.38795",
  "attribution-lib": "/attribution-lib/static-1.36954",
  "campaigns-lib": "/campaigns-lib/static-1.21529",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.51581",
  "content-intel-content-details-optimize-panel": "/content-intel-content-details-optimize-panel/static-1.6884",
  "content-management-actions-lib": "/content-management-actions-lib/static-1.21690",
  "ContentData": "/ContentData/static-1.62652",
  "ContentComponents": "/ContentComponents/static-2.65533",
  "ContentUtils": "/ContentUtils/static-1.62575",
  "customer-data-filters": "/customer-data-filters/static-1.46907",
  "customer-data-objects": "/customer-data-objects/static-1.6216",
  "customer-data-properties": "/customer-data-properties/static-1.44984",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6543",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11605",
  "error-messaging-js": "/error-messaging-js/static-1.3912",
  "ExportDialog": "/ExportDialog/static-6.9021",
  "file-manager-components": "/file-manager-components/static-1.17758",
  "foundations-assets": "/foundations-assets/static-1.3539",
  "foundations-components": "/foundations-components/static-1-gcm-text-color-inherit.6",
  "foundations-theming": "/foundations-theming/static-1.2933",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3447",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.2969",
  "immutable": "/immutable/static-2.19",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.7755",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.41174",
  "onboarding-tours": "/onboarding-tours/static-1.13932",
  "PortalIdParser": "/PortalIdParser/static-2.272",
  "property-translator": "/property-translator/static-1.4002",
  "quartz-core": "/quartz-core/static-1.4593",
  "quick-fetch": "/quick-fetch/static-1.2772",
  "react": "/react/static-7.151",
  "react-dom": "/react-dom/static-7.85",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.15222",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reporting-action-components": "/reporting-action-components/static-1.35532",
  "reporting-data": "/reporting-data/static-1.60951",
  "reporting-plugins": "/reporting-plugins/static-1.6394",
  "reporting-ui-components": "/reporting-ui-components/static-2.58232",
  "reporting-visualizations": "/reporting-visualizations/static-1.53031",
  "reselect": "/reselect/static-2.16",
  "sanitize-text": "/sanitize-text/static-1.6812",
  "segments-lib": "/segments-lib/static-1.26540",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "social-composer-lib": "/social-composer-lib/static-1.52753",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8547",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9649",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9536",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7520",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8237",
  "ui-addon-teams": "/ui-addon-teams/static-1.19512",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15771",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.8821",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7498",
  "ui-forms-editor-automation-lib": "/ui-forms-editor-automation-lib/static-1.58589",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.27627",
  "ui-product-approvals": "/ui-product-approvals/static-1.23381",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8668",
  "UIComponents": "/UIComponents/static-3.7060",
  "usage-tracker": "/usage-tracker/static-1.6087",
  "usage-tracker-container": "/usage-tracker-container/static-1.6077",
  "enviro": "/enviro/static-4.293",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3967",
  "raven": "/raven/static-3.4440",
  "raven-hubspot": "/raven-hubspot/static-1.4747",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.8343",
  "styled-components": "/styled-components/static-2.40",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2293",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1651",
  "quartz-webpack": "/quartz-webpack/static-1.1598",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-client-types": "/chatspot-client-types/static-1.8340",
  "chatspot-core": "/chatspot-core/static-1.14824",
  "copilot-toolkit": "/copilot-toolkit/static-1.5587",
  "cssUtils": "/cssUtils/static-1.459",
  "foundations-theming-base": "/foundations-theming-base/static-1.1918",
  "hs-story-utils": "/hs-story-utils/static-1.8014",
  "HubStyle": "/HubStyle/static-2.10420",
  "icons": "/icons/static-2.591",
  "msw": "/msw/static-1.39",
  "react-utils": "/react-utils/static-2.4179",
  "rpc-client-utils": "/rpc-client-utils/static-1.3351",
  "sanitize": "/sanitize/static-1.2997",
  "sassPrefix": "/sassPrefix/static-1.129",
  "ui-fonts": "/ui-fonts/static-1.331",
  "ui-images": "/ui-images/static-2.805",
  "usage-tracker-core": "/usage-tracker-core/static-1.5937",
  "graphql": "/graphql/static-1.58",
  "react-dnd-compat": "/react-dnd-compat/static-1.3268",
  "report-customization-components": "/report-customization-components/static-1.8204",
  "reporting-enablement": "/reporting-enablement/static-1.16305",
  "avatar-components": "/avatar-components/static-1.1031",
  "crm-links": "/crm-links/static-1.4743",
  "crm-message-bus": "/crm-message-bus/static-1.35888",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.5900",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.33093",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5480",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.6932",
  "framework-data-table": "/framework-data-table/static-2.8239",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2625",
  "HeadJS": "/HeadJS/static-2.563",
  "framer-motion": "/framer-motion/static-1.40",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1737",
  "testing-library": "/testing-library/static-1.120",
  "ts-schema": "/ts-schema/static-1.2990",
  "i18n-data": "/i18n-data/static-1.196",
  "moment-timezone": "/moment-timezone/static-5.51",
  "jasmine": "/jasmine/static-4.2971",
  "quartz-core-utils": "/quartz-core-utils/static-1.2241",
  "StyleGuideUI": "/StyleGuideUI/static-3.453",
  "reporting-client-types": "/reporting-client-types/static-1.1767",
  "flux-actions": "/flux-actions/static-1.266",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.8852",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9089",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "react-flip-move": "/react-flip-move/static-1.46",
  "reference-resolvers": "/reference-resolvers/static-1.6773",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.5284",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "transmute": "/transmute/static-2.29",
  "user-context": "/user-context/static-1.3778",
  "atom": "/atom/static-1.3865",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3335",
  "integrations-lib": "/integrations-lib/static-1.9831",
  "property-description-translator": "/property-description-translator/static-1.2466",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6577",
  "reporting-snowflake": "/reporting-snowflake/static-1.49575",
  "self-service-api": "/self-service-api/static-1.8813",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8058",
  "campaigns-build-lib": "/campaigns-build-lib/static-1.6936",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.2972",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11507",
  "hs-promise-utils": "/hs-promise-utils/static-1.4135",
  "superstore": "/superstore/static-1.3404",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.14819",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6499",
  "hs-lodash": "/hs-lodash/static-4.45",
  "content-intel-shared": "/content-intel-shared/static-1.7160",
  "cms-field-types": "/cms-field-types/static-1.3402",
  "FileManagerLib": "/FileManagerLib/static-1.33399",
  "video-data-lib": "/video-data-lib/static-1.28769",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "codemirror": "/codemirror/static-5.69",
  "content-embed-lib": "/content-embed-lib/static-1.5976",
  "data-token-picker": "/data-token-picker/static-1.13811",
  "data-token-views": "/data-token-views/static-1.13792",
  "FileManagerCore": "/FileManagerCore/static-1.33258",
  "forms-utils-lib": "/forms-utils-lib/static-1.9954",
  "growth-payments-core": "/growth-payments-core/static-1.20577",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.7245",
  "media-bridge-lib": "/media-bridge-lib/static-1.16422",
  "payment-link-components": "/payment-link-components/static-1.17875",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.8969",
  "products-ui-components": "/products-ui-components/static-1.34761",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "react-codemirror": "/react-codemirror/static-1.9223",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-tinymce": "/react-tinymce/static-1.49940",
  "react-virtualized": "/react-virtualized/static-2.73",
  "rich-text-lib": "/rich-text-lib/static-1.17156",
  "simple-menus-core": "/simple-menus-core/static-1.13332",
  "simple-menus-lib": "/simple-menus-lib/static-1.14850",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.49066",
  "tinymce-data": "/tinymce-data/static-1.35150",
  "tinymce-plugins": "/tinymce-plugins/static-1.52180",
  "tinymce-themes": "/tinymce-themes/static-1.51035",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.4733",
  "content-icons-ui": "/content-icons-ui/static-1.1863",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8358",
  "deep-diff": "/deep-diff/static-1.5",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.2910",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5385",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2797",
  "lodash": "/lodash/static-4.7",
  "commerce-products-lib": "/commerce-products-lib/static-1.4239",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2774",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.8990",
  "external-options-client-types": "/external-options-client-types/static-1.2938",
  "google-libphonenumber": "/google-libphonenumber/static-1.11",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3062",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2726",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-gcm-text-color-inherit.6",
  "floating-ui": "/floating-ui/static-1.28",
  "react-aria": "/react-aria/static-1.38",
  "tanstack-table": "/tanstack-table/static-1.23",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1416",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3410",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.11485",
  "growth-data-modal": "/growth-data-modal/static-1.3821",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1728",
  "navigation-components": "/navigation-components/static-1.13525",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6049",
  "ui-universal-auth": "/ui-universal-auth/static-1.7419",
  "dispatcher": "/dispatcher/static-1.111",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.635",
  "hubspotter-http": "/hubspotter-http/static-1.3420",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6844",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.334",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11022",
  "csstype": "/csstype/static-1.38",
  "content-assistance-lib": "/content-assistance-lib/static-1.6083",
  "dashboard-lib": "/dashboard-lib/static-1.75050",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7272",
  "immer": "/immer/static-1.33",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.2115",
  "reporting-reports": "/reporting-reports/static-1.60638",
  "account-and-billing-components": "/account-and-billing-components/static-1.16083",
  "growth-feature-usage-components": "/growth-feature-usage-components/static-1.4118",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-gcm-text-color-inherit.6",
  "magpie-lib": "/magpie-lib/static-1.4303",
  "navigation-messaging": "/navigation-messaging/static-1.2852",
  "feature-store-service-types": "/feature-store-service-types/static-1.3289",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3296",
  "salesImages": "/salesImages/static-1.498",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3280",
  "timezone-utils": "/timezone-utils/static-2.3886",
  "automation-contextual-components": "/automation-contextual-components/static-1.12877",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.12439",
  "automation-ui-template": "/automation-ui-template/static-1.39676",
  "automation-ui-types": "/automation-ui-types/static-1.13357",
  "forms-ai-lib": "/forms-ai-lib/static-1.2032",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-automation-embed": "/ui-addon-automation-embed/static-1.12063",
  "ui-forms-components": "/ui-forms-components/static-1.7949",
  "feedback-loader": "/feedback-loader/static-1.26234",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.7388",
  "html-to-image": "/html-to-image/static-1.29",
  "laboratory-lib": "/laboratory-lib/static-3.5879",
  "ui-addon-opt": "/ui-addon-opt/static-4.7280",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.3425",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.15525",
  "persist-promise": "/persist-promise/static-1.2367",
  "customer-data-associations": "/customer-data-associations/static-1.5828",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.10603",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4096",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6449",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.6703",
  "FileManagerImages": "/FileManagerImages/static-1.30909",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "audio-components": "/audio-components/static-1.4234",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.3166",
  "video-components": "/video-components/static-1.7123",
  "video-embed": "/video-embed/static-1.29612",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2402",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.3137",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3770",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2414",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17054",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.14250",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.30501",
  "crm_components": "/crm_components/static-3.86167",
  "crm_data": "/crm_data/static-4.86167",
  "customer-data-tracking": "/customer-data-tracking/static-1.5431",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-transition-group": "/react-transition-group/static-1.7",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "hub-http-contrib": "/hub-http-contrib/static-1.1802",
  "interframe": "/interframe/static-3.3421",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.3823",
  "layout-dnd-components": "/layout-dnd-components/static-1.10559",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.9534",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8082",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "products-iframe-lib": "/products-iframe-lib/static-1.2266",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7231",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.3833",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.3888",
  "fsm": "/fsm/static-1.2321",
  "policy-lib": "/policy-lib/static-1.5422",
  "idb-keyval": "/idb-keyval/static-1.20",
  "magpie-types": "/magpie-types/static-1.3763",
  "simple-logging-lib": "/simple-logging-lib/static-1.1665",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6539",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7397",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.21898",
  "onboarding-scopes": "/onboarding-scopes/static-1.5164",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.14832",
  "final-form": "/final-form/static-1.39",
  "fintech-outages-service-client-types": "/fintech-outages-service-client-types/static-1.11703",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.10025",
  "transactions-exp-service-client-types": "/transactions-exp-service-client-types/static-1.11699",
  "growth-feature-usage-data": "/growth-feature-usage-data/static-1.4337",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2055",
  "automation-templates-service-types": "/automation-templates-service-types/static-1.2782",
  "automation-ui-core": "/automation-ui-core/static-2.15293",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "form-builder-ui": "/form-builder-ui/static-1.7723",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2640",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1558",
  "immerable": "/immerable/static-1.2789",
  "social-insights-client-types": "/social-insights-client-types/static-1.17254",
  "outpost": "/outpost/static-1.2960",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.3133",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5081",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.12002",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.4947",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.14142",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.5367",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.5986",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6017",
  "crm_universal": "/crm_universal/static-1.20355",
  "customer-data-content": "/customer-data-content/static-1.24172",
  "crm_schema": "/crm_schema/static-3.86203",
  "customer-data-email": "/customer-data-email/static-1.15521",
  "layout-data-lib": "/layout-data-lib/static-1.7859",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2670",
  "sales-views-client-types": "/sales-views-client-types/static-1.2969",
  "trellis-story-utils": "/trellis-story-utils/static-1.3177",
  "immutable-less": "/immutable-less/static-1.3182",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8700",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.10872",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.13466",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6609",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2819",
  "stripe-connect-js": "/stripe-connect-js/static-1.37",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.2954",
  "utility-belt": "/utility-belt/static-1.1200",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.37381",
  "customer-data-rte": "/customer-data-rte/static-1.28465",
  "cv-backend-services": "/cv-backend-services/static-1.1110",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.3792",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.13061",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.9281",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3709",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.43",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.6837",
  "sequences-lib": "/sequences-lib/static-1.5650",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.8878",
  "apps-service-types": "/apps-service-types/static-1.2816",
  "oauth-service-types": "/oauth-service-types/static-1.2924",
  "nav-meta": "/nav-meta/static-1.25162",
  "react-window": "/react-window/static-1.13",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.6",
  "crm-actions": "/crm-actions/static-1.4683",
  "crm-fe-perf": "/crm-fe-perf/static-1.21608",
  "draft-content-plugins": "/draft-content-plugins/static-1.23789",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.18984",
  "knowledge-content-types": "/knowledge-content-types/static-1.7617",
  "FireAlarmUi": "/FireAlarmUi/static-1.3490",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5506"
}
};
